import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ResultActivityForm from './ResultActivityForm'

import { updateResultActivity } from '../services'
import { handleError } from '../../../helpers'

export default function EditResultActivityModal({ visible, onClose, resultActivity, reload, serviceResult }) {
	const { handleSubmit, register, formState: { errors }, watch } = useForm({ 
		defaultValues: { 
			order: resultActivity.order,
			description: resultActivity.description,
			quantity: resultActivity.quantity,
			volume: resultActivity.volume,
			value_per_unit: resultActivity.value_per_unit,
		}
	})
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		updateResultActivity(resultActivity.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<ResultActivityForm 
						register={register}
						errors={errors}
						watch={watch}
						editable
						serviceResult={serviceResult}
					/>
					<Button color='primary' type="submit" disabled={loading}>
						{ loading && <Spinner animation="border" size="sm" className='mr-1' /> }
						Actualizar Registro
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}